const THEME_CACHE_KEY = 'cf_ui_theme';
const VALID_THEMES = ['light', 'dark'];
const themeListeners = new Set();

/* global __APP_PLATFORM__ */

function isActivatePlatform() {
	return typeof __APP_PLATFORM__ !== 'undefined' && __APP_PLATFORM__ === 'activate_iq';
}

function getEffectiveTheme(theme) {
	if (!isActivatePlatform()) {
		return 'light';
	}
	return VALID_THEMES.includes(theme) ? theme : 'light';
}

function getCachedTheme() {
	try {
		return localStorage.getItem(THEME_CACHE_KEY);
	} catch (_e) {
		return null;
	}
}

function setCachedTheme(theme) {
	try {
		if (theme) {
			localStorage.setItem(THEME_CACHE_KEY, theme);
		}
	} catch (_e) {
		// localStorage may be unavailable
	}
}

function clearCache() {
	try {
		localStorage.removeItem(THEME_CACHE_KEY);
	} catch (_e) {
		// localStorage may be unavailable
	}
}

function initCurrentTheme() {
	if (typeof document === 'undefined') {
		return 'light';
	}
	const domTheme = document.documentElement.dataset.theme;
	if (domTheme) {
		return getEffectiveTheme(domTheme);
	}
	const cachedTheme = getCachedTheme();
	if (cachedTheme) {
		return getEffectiveTheme(cachedTheme);
	}
	return 'light';
}

let currentTheme = initCurrentTheme();

if (typeof document !== 'undefined' && !document.documentElement.dataset.theme) {
	document.documentElement.dataset.theme = currentTheme;
}

function notifyThemeListeners(theme) {
	themeListeners.forEach((listener) => listener(theme));
}

function applyRuntimeTheme(theme) {
	const effectiveTheme = getEffectiveTheme(theme);
	const themeChanged = effectiveTheme !== currentTheme;

	currentTheme = effectiveTheme;
	if (typeof document !== 'undefined') {
		document.documentElement.dataset.theme = effectiveTheme;
	}
	setCachedTheme(effectiveTheme);

	if (themeChanged) {
		notifyThemeListeners(effectiveTheme);
	}

	return effectiveTheme;
}

function getCurrentTheme() {
	return currentTheme;
}

function subscribeThemeChange(callback) {
	if (typeof callback !== 'function') {
		return () => {};
	}
	themeListeners.add(callback);
	return () => themeListeners.delete(callback);
}

const themeRuntime = {
	isActivatePlatform,
	getEffectiveTheme,
	applyRuntimeTheme,
	getCurrentTheme,
	subscribeThemeChange,
	getCachedTheme,
	setCachedTheme,
	clearCache
};

export default themeRuntime;
